export const MESSAGES_CHUNK_SIZE = 20;
export const CONVERSATIONS_CHUNK_SIZE = 20;
